<mat-form-field class="full-width">
  <input matInput id="member-search-{{ id || '1' }}" [formControl]="memberCtrl" [matAutocomplete]="auto" name="member" placeholder="Search...">
</mat-form-field>

<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
  <mat-option *ngFor="let member of filteredMembers" [value]="member" (click)="selectMember()">
    {{ member.firstName }} {{ member.lastName }} ({{ member.email }})
  </mat-option>
</mat-autocomplete>
